/**
 * Hero buy card for the S'more intro page.
 *
 * Surfaces a single product option (the colourway) and maps each value to one
 * representative variant, preferring an in-stock one. The remaining options
 * (e.g. size) are not shown; the buy button always submits a concrete variant id
 * to the theme's <product-form>, which handles the AJAX add and opens the drawer.
 */
if (!customElements.get('smore-buy-variants')) {
  customElements.define(
    'smore-buy-variants',
    class SmoreBuyVariants extends HTMLElement {
      connectedCallback() {
        const buttons = Array.from(this.querySelectorAll('[data-color-value]'));
        const input = this.querySelector('[name="id"]');
        const buyButton = this.querySelector('.single-add-to-cart-button');
        const price = this.querySelector('[data-buy-price]');
        const compare = this.querySelector('[data-buy-compare]');

        if (!buttons.length || !input || !buyButton || !price) return;

        let variants;
        try {
          variants = JSON.parse(this.dataset.variants || '[]');
        } catch (error) {
          return;
        }
        if (!variants.length) return;

        const optionIndex = parseInt(this.dataset.optionIndex, 10) || 0;

        const byValue = new Map();
        variants.forEach((variant) => {
          const value = variant.options[optionIndex];
          const current = byValue.get(value);
          if (!current || (!current.available && variant.available)) {
            byValue.set(value, variant);
          }
        });

        const select = (colorButton, variant) => {
          buttons.forEach((button) => {
            const isActive = button === colorButton;
            button.classList.toggle('is-active', isActive);
            button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });

          input.value = variant.id;
          price.textContent = variant.price;

          if (compare) {
            compare.textContent = variant.compare_at_price || '';
            compare.hidden = !variant.compare_at_price;
          }

          buyButton.disabled = !variant.available;
          buyButton.classList.toggle('sold-out', !variant.available);

          const label = buyButton.querySelector('.single-add-to-cart-button--text');
          if (label) {
            label.textContent = variant.available ? this.dataset.labelAdd : this.dataset.labelSoldout;
          }
        };

        buttons.forEach((button) => {
          const variant = byValue.get(button.dataset.colorValue);
          if (!variant || !variant.available) button.classList.add('is-unavailable');

          button.addEventListener('click', () => {
            if (variant) select(button, variant);
          });
        });

        const initial = variants.find((variant) => String(variant.id) === input.value);
        if (!initial) return;

        const initialButton = buttons.find((button) => button.dataset.colorValue === initial.options[optionIndex]);
        if (initialButton) {
          initialButton.classList.add('is-active');
          initialButton.setAttribute('aria-pressed', 'true');
        }
      }
    }
  );
}
